import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats, filteredCount, totalCount }) => {
  const statCards = [
    {
      label: 'Total Methodologies',
      value: totalCount?.toLocaleString(),
      icon: 'BookOpen',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Filtered Results',
      value: filteredCount?.toLocaleString(),
      icon: 'Filter',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'High Risk',
      value: stats?.highRisk?.toLocaleString(),
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    {
      label: 'Recently Revised',
      value: stats?.recentlyRevised?.toLocaleString(),
      icon: 'RefreshCw',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Peer Reviewed',
      value: stats?.peerReviewed?.toLocaleString(),
      icon: 'Users',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Avg Rating',
      value: stats?.avgRating?.toFixed(1),
      icon: 'Star',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className={`p-2 rounded-lg ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={16} className={stat?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-lg font-semibold text-card-foreground">
                {stat?.value}
              </div>
              <div className="text-xs text-muted-foreground truncate">
                {stat?.label}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;